import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  AlertTriangle,
  ArrowLeft,
  RefreshCw,
  ShieldCheck,
} from "lucide-react";

export default function InstagramConnectionFailed() {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6 py-16 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-2xl rounded-[2rem] border border-ink/10 bg-white p-8 shadow-sm md:p-12"
          data-testid="instagram-connect-failed-page"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-peach">
            <AlertTriangle
              size={38}
              className="text-hotpink"
              strokeWidth={2.4}
            />
          </div>

          <p className="mt-8 text-center text-xs font-bold uppercase tracking-[0.25em] text-hotpink">
            Instagram Connection Failed
          </p>

          <h1 className="mt-3 text-center font-display text-4xl tracking-tighter md:text-5xl">
            We couldn't connect
            <br />
            your Instagram account.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-ink/65">
            Your Instagram Business account was not connected successfully.
            This usually happens if the authorization was cancelled,
            expired, or Instagram couldn't verify the request.
          </p>

          <div className="mt-10 rounded-3xl border border-ink/10 bg-cream p-6">
            <p className="text-sm font-semibold text-ink">
              Common reasons
            </p>

            <ul className="mt-4 space-y-3 text-sm text-ink/65">
              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Instagram authorization was cancelled.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Authorization expired before completion.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                The selected account isn't an Instagram Business account.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Temporary network or Meta service issue.
              </li>
            </ul>
          </div>

          <div className="mt-10 flex flex-col gap-4 md:flex-row">
            <Link
              to="/login"
              data-testid="retry-instagram-connect"
              className="cta-glow inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-sunset-gradient px-6 py-3 text-sm font-semibold text-white"
            >
              <RefreshCw size={16} />
              Try Again
            </Link>

            <Link
              to="/"
              data-testid="back-home"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-ink/10 bg-white px-6 py-3 text-sm font-semibold text-ink hover:bg-ink/5"
            >
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </div>

          <p className="mt-8 text-center text-xs text-ink/50">
            If this problem continues, disconnect Checkout DM from Instagram,
            then try connecting again.
          </p>
        </motion.div>
      </div>
    </div>
  );
}